<template>
<e-chart ref="chart" />
</template>

<script>
import BaseFactorChart from './BaseFactorChart'
import EChart from '../../Charts/ECharts'

export default {
  name: 'DefaultFactorChart',
  components: {EChart},
  extends: BaseFactorChart,
  methods: {
    setSeries (chartOpt, unitMap) {
      let factors = this.factorGroup.children
      let {data, unitProp} = this

      chartOpt.series = factors.map(factor => {
        let {id, name} = factor
        let unit = factor[unitProp]

        return {
          id,
          name,
          type: 'line',
          yAxisIndex: unitMap[unit],
          symbol: 'none',
          data: data.map(data => {
            let value = data[id]
            return Number.isFinite(value) ? value : NaN
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/FactorCharts/DefaultFactorChart.vue